module.exports = __webpack_public_path__ + "static/assets/44871e86d2e95d574b4a599208f0d757.svg";